module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 switch(type) {
  case 'facebook': ;
__p += '\n    <button type="button" class="' +
((__t = ( styles.socialButton )) == null ? '' : __t) +
'" aria-label="Facebook" title="Facebook" data-social-button="FACEBOOK">\n      ' +
((__t = ( facebook() )) == null ? '' : __t) +
'\n    </button>';

    break;
  case 'twitter': ;
__p += '\n    <button type="button" class="' +
((__t = ( styles.socialButton )) == null ? '' : __t) +
'" aria-label="Twitter" title="Twitter" data-social-button="TWITTER">\n      ' +
((__t = ( twitter() )) == null ? '' : __t) +
'\n    </button>';

    break;
  case 'instagram': ;
__p += '\n    <button type="button" class="' +
((__t = ( styles.socialButton )) == null ? '' : __t) +
'" aria-label="Instagram" title="Instagram" data-social-button="INSTAGRAM">\n      ' +
((__t = ( instagram() )) == null ? '' : __t) +
'\n    </button>';

    break;
} ;
__p += '\n';

}
return __p
}